export const SET_ALL_POSTS = "SET_ALL_POSTS"
export const SET_POST= "SET_POST"
export const DELETE_POST = "DELETE_POST"